"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const consts_1 = require("~/store/consts");
const UI_1 = require("~/components/UI");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const assets_1 = require("~/assets");
const actions_1 = require("~/store/actions");
const BOMItemPrice_1 = __importDefault(require("../BOMItemPrice"));
const PriceTooltip_1 = __importDefault(require("../PriceTooltip"));
const BOMItemServices_scss_1 = __importDefault(require("./BOMItemServices.scss"));
const BOMItemNotesButton_1 = require("../BOMItemNotesButton");
const BOMItemServiceNotes_1 = __importDefault(require("../BOMItemServiceNotes/BOMItemServiceNotes"));
const BOMLineItemUtils_1 = require("../BOMLineItemUtils");
function BOMItemServices({ services, isImperialMeasurement, projectItem, manuallyAdded = false, parentLineItemNumber, }) {
    var _a;
    const [isDescriptionOverflowing, setDescriptionOverflowing] = (0, react_1.useState)(false);
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const quantityInputRef = (0, react_1.useRef)(null);
    const manuallyAddedMachiningServices = (0, react_redux_1.useSelector)(selectors_1.selectManuallyAddedMachiningServices);
    const BOMWidgetState = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetState)(consts_1.WIDGETS.BOM_WIDGET));
    const isBOMLoading = (0, react_redux_1.useSelector)(selectors_1.selectBOMLoading) === types_1.LOADING_STATE.LOADING;
    const [showNotes, setShowNotes] = (0, react_1.useState)({});
    const [notesWidgetY, setNotesWidgetY] = (0, react_1.useState)(0);
    const projectItemUUID = (_a = projectItem.uuid[0]) !== null && _a !== void 0 ? _a : '';
    const { dispatchDeleteManuallyAddedMS, dispatchAddManuallyDeletedMS } = (0, redux_1.bindActionCreators)({
        dispatchDeleteManuallyAddedMS: actions_1.deleteManuallyAddedMachiningService,
        dispatchAddManuallyDeletedMS: actions_1.addManuallyDeletedMachiningService,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        const showNotesList = {};
        services.forEach((service) => {
            showNotesList[service.id] = false;
        });
        setShowNotes(showNotesList);
    }, [services]);
    const createOpenNotesHandler = (service) => (event) => {
        if (!showNotes[service.id]) {
            setShowNotes((prevShowNotes) => (Object.assign(Object.assign({}, prevShowNotes), { [service.id]: true })));
            setNotesWidgetY(event.clientY - BOMWidgetState.position.y);
        }
    };
    const createNoteShowUpdateHandler = (service) => (show) => {
        setShowNotes((prevShowNotes) => (Object.assign(Object.assign({}, prevShowNotes), { [service.id]: show })));
    };
    const changeQuantityHandler = (value, item) => {
        let newValue = Number.parseInt(value, 10);
        newValue = Math.min(Math.max(newValue, 1), 999999);
        if (Number(value) === item.quantity) {
            return;
        }
        document.body.dispatchEvent((0, events_1.updateServicesToBOMEvent)([
            {
                quantity: newValue,
                machiningServiceId: item.id,
                projectItemUUID,
            },
        ]));
    };
    const handleDeleteService = (bomItem) => {
        var _a;
        document.body.dispatchEvent((0, events_1.removeServicesFromBOMEvent)([
            {
                machiningServiceId: bomItem.id,
                projectItemUUID,
            },
        ]));
        // here below is the part for "Cancel" functionality
        const alreadyAddedMSWithSameType = (_a = manuallyAddedMachiningServices[projectItemUUID]) === null || _a === void 0 ? void 0 : _a.find((ms) => ms.machiningServiceId === bomItem.id);
        if (alreadyAddedMSWithSameType) {
            if (alreadyAddedMSWithSameType.projectItemUUID) {
                dispatchDeleteManuallyAddedMS({
                    projectItemUUID: alreadyAddedMSWithSameType.projectItemUUID,
                    machiningServiceId: alreadyAddedMSWithSameType.machiningServiceId,
                });
            }
        }
        else {
            dispatchAddManuallyDeletedMS({
                projectItemUUID,
                machiningServiceId: bomItem.id,
                quantity: bomItem.quantity,
                notes: bomItem.notes,
            });
        }
    };
    const canServiceBeDeleted = (service) => {
        return isBOMEditMode && service.manuallyAdded;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, services.map((service, serviceIndex) => {
        var _a, _b, _c, _d;
        const lineItemNumber = (0, BOMLineItemUtils_1.getChildLineItemNumber)(parentLineItemNumber, serviceIndex);
        const descriptionElement = (react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.description }, (_c = (_b = (isImperialMeasurement ? service.description : (_a = service.descriptionSI) !== null && _a !== void 0 ? _a : service.description)) === null || _b === void 0 ? void 0 : _b.split('\n')) === null || _c === void 0 ? void 0 :
            _c.map((string) => (react_1.default.createElement("div", { key: string, className: BOMItemServices_scss_1.default.itemTextWithEllipsis }, string))),
            !service.manuallyAdded && service.serviceMetadata ? (react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemMachiningNotes }, isImperialMeasurement
                ? service.serviceMetadata.imperialMetadata
                : service.serviceMetadata.metricMetadata)) : null));
        return (react_1.default.createElement("div", { key: `${service.item_number}-${service.id}`, className: BOMItemServices_scss_1.default.item },
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.arrow }),
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemLineItem }, lineItemNumber),
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemImg },
                service.image && react_1.default.createElement("img", { src: (0, utils_1.formatAssetsURL)((_d = service.image) === null || _d === void 0 ? void 0 : _d.url), alt: service.description }),
                canServiceBeDeleted(service) && (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                react_1.default.createElement("div", { style: { cursor: 'pointer' }, className: BOMItemServices_scss_1.default.trashImg, onClick: () => handleDeleteService(service) },
                    react_1.default.createElement("img", { src: assets_1.svgBasicTrashIcon, alt: "Icon trash" })))),
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemNumber }, `#${service.item_number}`),
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemDescription, onMouseOver: (e) => setDescriptionOverflowing((0, utils_1.isEventTargetOverflowing)(e)) },
                react_1.default.createElement(UI_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.tooltip }, descriptionElement), disabled: !isDescriptionOverflowing }, descriptionElement)),
            react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemSize }),
            manuallyAdded && isBOMEditMode ? (react_1.default.createElement(UI_1.Input, { type: "number", className: BOMItemServices_scss_1.default.itemInputNumber, value: service.quantity, onChange: (e) => {
                    changeQuantityHandler(e, service);
                }, min: 1, max: 999999, arrows: true, ref: quantityInputRef })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: BOMItemServices_scss_1.default.itemQuantity }, service.quantity),
                react_1.default.createElement(PriceTooltip_1.default, { price: service.price, unitOfMeasurement: service.unitOfMeasurement || '' }))),
            react_1.default.createElement(BOMItemPrice_1.default, { price: service.sum || 0, discountedPrice: service.discountedSum !== service.sum ? service.discountedSum : undefined }),
            service.manuallyAdded ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(BOMItemNotesButton_1.BOMItemNotesButton, { onClick: createOpenNotesHandler(service), notesShown: showNotes[service.id], isNotesPresent: () => { var _a; return !!((_a = service.rawServiceMetadata) === null || _a === void 0 ? void 0 : _a.length); }, disabled: isBOMLoading }),
                showNotes[service.id] && (react_1.default.createElement(BOMItemServiceNotes_1.default, { show: showNotes[service.id], item: projectItem, service: service, updateShowHandler: createNoteShowUpdateHandler(service), y: notesWidgetY })))) : (react_1.default.createElement("div", { style: { width: '25px' } }))));
    })));
}
exports.default = BOMItemServices;
